import { render, staticRenderFns } from "./customTabTime.vue?vue&type=template&id=6c58cebb&scoped=true"
import script from "./customTabTime.vue?vue&type=script&lang=js"
export * from "./customTabTime.vue?vue&type=script&lang=js"
import style0 from "./customTabTime.vue?vue&type=style&index=0&id=6c58cebb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58cebb",
  null
  
)

export default component.exports